/**
 * Guarda despesa ocasional anual. Cofre só se `payload.create_smoothing_pot` for true.
 * @param {{ payload: object, createAnnual: Function }} opts
 */
export async function saveAnnualOccasional({ payload, createAnnual }) {
  return createAnnual(payload);
}
